export const reactSpringMessagesPortal = document.getElementById('spring-messages') as HTMLElement;
export const reactSpringPortal = document.getElementById('spring') as HTMLElement;
export const backgroundsPortal = document.getElementById('backgrounds') as HTMLElement;
export const appPortal = document.getElementById('app') as HTMLElement;
